<template>
    <div class="login__footer">
        <ButtonCommon
            :isNoHover="true"
            :isLoading="isLoadingButton"
            :isLoadingWhiteColor="true"
            type="active"
            value="login"
            @on-click-button-common="onClickLogin"
        />
    </div>
</template>
<script>
import ButtonCommon from '@/components/common/button/button.vue';
import AuthService from '@/services/auth.service';

import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';

import EventBus from '@/utils/EventBus';
import { isStrEmpty } from '@/utils/utils';

export default {
    mixins: [languageMixins, utilsMixin],
    components: { ButtonCommon },
    data() {
        return {
            dataForm: {
                userId: '',
                password: '',
            },
            isLoadingButton: false,
        };
    },
    created() {
        EventBus.on('on-change-value-login', (payload) => {
            this.changeValueLogin(payload);
        });
    },
    unmounted() {
        EventBus.off('on-change-value-login');
    },
    methods: {
        async onClickLogin() {
            try {
                let paramValiabel = {
                    type: 'userId',
                    isValiabel: true,
                };

                if (isStrEmpty(this.dataForm.userId)) {
                    EventBus.emit('show-validate-login', paramValiabel);
                    if (isStrEmpty(this.dataForm.password)) {
                        paramValiabel.type = 'password';
                        EventBus.emit('show-validate-login', paramValiabel);
                    }
                    return false;
                }

                if (isStrEmpty(this.dataForm.password)) {
                    paramValiabel.type = 'password';
                    EventBus.emit('show-validate-login', paramValiabel);
                    return false;
                }

                this.isLoadingButton = true;
                const param = {
                    terminal_id: this.dataForm.userId,
                    terminal_pin: this.dataForm.password,
                    login_method: 'terminal',
                };
                const res = await AuthService.login(param);
                if (res.code === 200 || res.status === '200' || res.status === 'success') {
                    let payload = {
                        tokenV3: res.data.gamev3.token,
                        token: res.data.token,
                        userInfo: {
                            terminalId: this.dataForm.userId,
                            ...res.data
                        },

                    };
                    this.$store.dispatch('setLogin', payload);
                    this.$router.go('/');
                } else {
                    let message = '';
                    !this.isArrayEmpty(res.errors)
                        ? res.errors.forEach((element) => {
                              message += element.message;
                          })
                        : (message = res.message);
                    const param = {
                        text: message,
                        type: 'error',
                    };
                    EventBus.emit('show-notications', param);
                }
                this.isLoadingButton = false;
            } catch (error) {
                this.isLoadingButton = false;
                const param = {
                    text: error?.message,
                    type: 'error',
                };
                EventBus.emit('show-notications', param);
            }
        },

        changeValueLogin(payload) {
            let { event, name } = payload;

            if (isStrEmpty(this.dataForm[name])) {
                const paramValiabel = {
                    type: name,
                    isValiabel: false,
                };
                EventBus.emit('show-validate-login', paramValiabel);
            }

            this.dataForm[name] = event.target.value;
        },
    },
};
</script>
